export default function ($sceDelegateProvider, $windowProvider) {
    'ngInject';

    $sceDelegateProvider.resourceUrlWhitelist([
        // Allow same origin resource loads.
        'self',
        // Allow loading from our assets domain.
        `${$windowProvider.$get().assetsURL}**`
    ]);
}



// WEBPACK FOOTER //
// ./src/js/config/sceDelegateProvider.js